
import { useState, useEffect } from 'react';

export default function HomePage() {
  useEffect(() => {
    // Add Schema.org JSON-LD
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "貝原守",
      "jobTitle": "保険営業専門・目標達成トレーナー",
      "description": "証券会社の営業として勤務後、保険代理店研修生を経て保険代理店として独立。以後、保険営業として２０年以上、第一線で従事。のべ３５年以上の営業経験を生かして保険営業コンサルタントに転身。",
      "image": "https://static.readdy.ai/image/2edc92dcd511e1b7f15cb4c8ce462ac7/4144a7fea96cfef273bae5c943ddfa84.jpeg",
      "url": siteUrl,
      "knowsAbout": ["保険営業", "営業コンサルティング", "目標達成トレーニング", "MDRT"]
    };

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "保険営業専門・個別コンサルティング",
      "provider": {
        "@type": "Person",
        "name": "貝原守"
      },
      "description": "保険営業専門の目標達成トレーナー貝原守による個別コンサルティングコース。40〜50代の女性保険営業マンを対象に、ZOOMでの個別サポートを月4回提供。営業成果を加速させます。",
      "offers": {
        "@type": "Offer",
        "price": "15000",
        "priceCurrency": "JPY",
        "description": "個別コンサルティング（1回15分×月４回）をZOOMで実施"
      },
      "areaServed": {
        "@type": "Country",
        "name": "日本"
      }
    };

    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "保険営業専門・個別コンサルティングコース",
      "description": "保険営業専門の目標達成トレーナー貝原守による個別コンサルティングコース。40〜50代の女性保険営業マンを対象に、ZOOMでの個別サポートを月4回提供。営業成果を加速させます。",
      "url": siteUrl,
      "author": {
        "@type": "Person",
        "name": "貝原守"
      },
      "publisher": {
        "@type": "Person",
        "name": "貝原守"
      }
    };

    // Insert schemas
    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(personSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(webPageSchema);
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 245, 238, 0.9), rgba(254, 242, 242, 0.9)), url('https://public.readdy.ai/ai/img_res/b3b9132a913fbe85c26143c67a8f919a.jpg')`
        }}
      >
        <div className="container mx-auto px-6 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-6 leading-tight">
                保険営業専門<br />
                <span className="text-rose-600">個別コンサルティングコース</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium">
                あなたに寄り添い、結果を加速させます！
              </p>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-rose-100">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">こんなことができます！</h2>
                <div className="grid md:grid-cols-2 gap-4 text-left">
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">日々の現場、会社の方針にあわせた行動のアレンジ</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">お客さんの心に届く、ツール類の添削</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">効果的なトークの作成、トークの練習</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">営業先で使えるアイディア出し</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">会社ツールの活用法アレンジ</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-rose-500 text-xl mt-1"></i>
                    <span className="text-gray-700">商談を生み出す商品切り口のアイディア出し</span>
                  </div>
                </div>
              </div>
            </div>
            <a 
              href="https://form.os7.biz/f/ee14cc68/" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-rose-600 hover:bg-rose-7 text-white font-bold py-4 px-12 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              今すぐ申し込む
            </a>
          </div>
        </div>
      </section>

      {/* Service Details Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">個別コンサルの形式・内容</h2>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="w-full h-80 rounded-2xl shadow-lg overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/2edc92dcd511e1b7f15cb4c8ce462ac7/d367ab69d563d171e1995555d3c8bb59.jpeg"
                    alt="オンラインコンサルティング"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="space-y-6">
                <div className="bg-rose-50 p-6 rounded-xl border border-rose-100">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">形式・内容</h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    個別コンサルティング（1回15分×月４回）を<br />
                    ZOOMで実施します。
                  </p>
                </div>
                <div className="bg-orange-50 p-6 rounded-xl border border-orange-100">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">特徴</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start space-x-3">
                      <i className="ri-time-line text-orange-500 text-xl mt-1"></i>
                      <span>月4回の継続的なサポート</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-video-line text-orange-500 text-xl mt-1"></i>
                      <span>ZOOMでのオンライン実施</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-user-line text-orange-500 text-xl mt-1"></i>
                      <span>完全個別対応</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 bg-gradient-to-r from-rose-50 to-pink-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-12">個別コンサルの費用</h2>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-rose-100 mb-8">
              <div className="text-6xl font-bold text-rose-600 mb-4">¥15,000</div>
              <div className="text-xl text-gray-600 mb-6">（税込み）</div>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4">
                <p>
                  １つのアドバイスが契約に直結したり、苦痛だった保険営業が楽しくできるようになることも多々。
                </p>
                <p>
                  また、行動習慣が変わることによるその後の心理・仕事面でのインパクトは計り知れませんので、
                  この個別コンサルフィーは、<strong className="text-rose-600">１時間最低５万円以上の価値</strong>があると自負しています。
                </p>
                <p>
                  しかし「少しでも多くの保険営業マンの方の人生を応援したい」という思いから、
                  <strong className="text-rose-600">１５，０００円（税込み）</strong>の費用で実施させていただいています。
                </p>
                <p className="text-sm text-gray-500 mt-6">
                  ※価格はご案内なく変更させていただくこともあります。ご了承ください。
                </p>
              </div>
            </div>
            <a 
              href="https://form.os7.biz/f/ee14cc68/" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-rose-600 hover:bg-rose-7 text-white font-bold py-4 px-12 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              今すぐ申し込む！
            </a>
          </div>
        </div>
      </section>

      {/* Instructor Profile Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">講師プロフィール</h2>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="text-center">
                <div className="w-80 h-96 mx-auto mb-6 rounded-2xl shadow-lg overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/2edc92dcd511e1b7f15cb4c8ce462ac7/4144a7fea96cfef273bae5c943ddfa84.jpeg"
                    alt="貝原守講師"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="bg-rose-50 p-6 rounded-xl border border-rose-100">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">座右の銘</h3>
                  <p className="text-lg text-rose-600 font-medium">
                    「花よりも花を咲かせる土になれ」
                  </p>
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-2">
                    保険営業専門・目標達成トレーナー
                  </h3>
                  <h4 className="text-2xl font-bold text-rose-600 mb-6">
                    貝原 守（かいはら まもる）
                  </h4>
                </div>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    証券会社の営業として勤務後、保険代理店研修生を経て保険代理店として独立。
                    以後、保険営業として２０年以上、第一線で従事。
                  </p>
                  <p>
                    のべ３５年以上の営業経験を生かして保険営業コンサルタントに転身。
                    保険営業コンサルタントとして数々の実績を作る。
                  </p>
                </div>
                <div className="bg-orange-50 p-6 rounded-xl border border-orange-100">
                  <h4 className="text-xl font-bold text-gray-800 mb-4">主な実績</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start space-x-3">
                      <i className="ri-trophy-line text-orange-500 text-lg mt-1"></i>
                      <span>損保営業が初のＭＤＲＴ獲得、２年連続ＭＤＲＴ達成</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-trophy-line text-orange-500 text-lg mt-1"></i>
                      <span>新人保険営業レディが年間保険料10倍、3,000万の契約を獲得</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-trophy-line text-orange-500 text-lg mt-1"></i>
                      <span>面談回数を2/3に減らし、保険単価２倍を達成</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-trophy-line text-orange-500 text-lg mt-1"></i>
                      <span>お客さん10人の保険営業レディが9ヶ月で600人顧客獲得</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-rose-50 p-6 rounded-xl border border-rose-100">
                  <p className="text-gray-700 leading-relaxed">
                    豊かな土になり一人でも多くの保険に携わる人を「しあわせ」にする。
                    そして、その先にいるより多くのお客様の「あんしん」につなげて行きます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-rose-50 via-pink-50 to-orange-50">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">個別コンサルティング申し込み</h2>
            <p className="text-xl text-gray-700 mb-12">
              あなたの保険営業を次のレベルへ。今すぐお申し込みください。
            </p>
            <a 
              href="https://form.os7.biz/f/ee14cc68/" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-rose-600 hover:bg-rose-7 text-white font-bold py-6 px-16 rounded-full text-2xl transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              今すぐ申し込む
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">保険営業専門・目標達成トレーナー　貝原守</h3>
            <p className="text-gray-300 mb-6">
              あなたの保険営業を次のレベルへ導きます
            </p>
            <div className="border-t border-gray-700 pt-6">
              <p className="text-gray-400 text-sm">
                © 2025 貝原守 個別コンサルティングコース. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
